import React from "react";
import { observer } from "mobx-react";
//import TextField from "@mui/material/TextField";
import {
  FormHelperText,
  FormControl,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { IMaskInput } from "react-imask";

import { NumericFormat } from "react-number-format";

import "../index.css";

function TextFieldMask(props) {
  const {
    id,
    label,
    error,
    helperText,
    className,
    variant,
    type,
    textProps,
    inputProps,
    mask,
    maskDefinitions,
    isDecimal,
    inputComponent,
    ...other
  } = props;
  const { definitions, ...otherDef } = maskDefinitions ?? {};
  function NumericFormatCustom(props) {
    const { inputRef, onChange, tip, colkey, ...other } = props;
    return (
      <NumericFormat
        {...other}
        getInputRef={inputRef}
        thousandSeparator="."
        decimalSeparator=","
        fixedDecimalScale
        valueIsNumericString
        style={{ textAlign: "right" }}
      />
    );
  }
  const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
    const { onChange, ...otherp } = props;
    return (
      <IMaskInput
        inputRef={ref}
        {...otherp}
        mask={mask}
        definitions={
          definitions ?? { 9: /[0-9]/, /*a: /[a-z]/,*/ "#": /[0-9, a-z]/ }
        }
        {...otherDef}
        onAccept={(value) => onChange({ target: { name: props.name, value } })}
        overwrite
      />
    );
  });

  const component = (isDecimal || mask) && {
    inputComponent: isDecimal ? NumericFormatCustom : mask && TextMaskCustom,
  };
  return (
    <FormControl className={className} variant={variant} error={error}>
      <InputLabel>{label}</InputLabel>
      <OutlinedInput
        //className={className}
        id={id}
        label={label}
        type={type || "text"}
        {...component}
        {...other}
        {...inputProps}
      />
      <FormHelperText id={`${id}ht`}>{helperText}</FormHelperText>
    </FormControl>
  );
}
export default observer(TextFieldMask);
